import { useThree } from '@react-three/fiber';
import { useSpring, easings } from '@react-spring/three';
import { Color } from 'three';
import { useEffect } from 'react';
import { useExperienceStore } from '../../store';

interface BackgroundProps {
  backgroundColor: string;
}

export function Background({ backgroundColor }: BackgroundProps) {
  const { scene } = useThree();
  const { currentState } = useExperienceStore((state) => ({
    currentState: state.currentState,
  }));

  useSpring({
    sceneBackground: backgroundColor === 'white' ? 'white' : 'black',
    config: {
      duration: 300,
      easing: easings.linear,
    },
    onChange: ({ value }) => {
      if (currentState === 'outro') return;

      scene.background = new Color(value.sceneBackground);
    },
  });

  useEffect(() => {
    scene.background = new Color(backgroundColor);
  }, [backgroundColor, scene]);

  return null;
}
